import { render, staticRenderFns } from "./GAccountContract.vue?vue&type=template&id=2e307fc5&scoped=true&"
import script from "./GAccountContract.vue?vue&type=script&lang=ts&"
export * from "./GAccountContract.vue?vue&type=script&lang=ts&"
import style0 from "./GAccountContract.vue?vue&type=style&index=0&id=2e307fc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e307fc5",
  null
  
)

export default component.exports